import React from 'react';

import {ProfileContext} from './ProfileContext';
import {Role} from 'types/role';
import type {CourseUser} from './ProfileContext';
import {isMinimumRole} from './profileUtil';

type GatePredicate = (user: CourseUser) => boolean;

/**
 * @deprecated Use the profileUtil functions instead.
 * The Gate component allows for rendering content based on the user
 * permissions without each client needing to understand the internal
 * implementation of the permissions model.
 *
 * It must be used within a ProfileProvider; otherwise it defaults
 * to hiding all content.
 */
type GateProps = {
  children: React.ReactNode;
  when: GatePredicate;
};

/**
 * @deprecated Use the profileUtil functions instead.
 * The Gate component allows for rendering content based on the user
 * permissions without each client needing to understand the internal
 * implementation of the permissions model.
 *
 * It must be used within a ProfileProvider; otherwise it defaults
 * to hiding all content.
 */
const Gate = ({children, when}: GateProps) => {
  const {userData} = React.useContext(ProfileContext);
  if (!userData) {
    return null;
  }

  if (!when(userData)) {
    return null;
  }

  return <>{children}</>;
};

/**
 * @deprecated Use the profileUtil functions instead.
 * Checks if a user has this role OR GREATER!
 */
Gate.hasRole = (role: Role) => (user: CourseUser) => {
  return user && isMinimumRole(user.courseRole, role);
};

/**
 * @deprecated Use the profileUtil functions instead.
 */
Gate.hasSectionLeaderRole = Gate.hasRole(Role.SECTION_LEADER);

/**
 * @deprecated Use the profileUtil functions instead.
 */
Gate.hasAdminRole = Gate.hasRole(Role.ADMIN);

/**
 * @deprecated Use the profileUtil functions instead.
 */
Gate.hasStudentRole = Gate.hasRole(Role.STUDENT);

/**
 * @deprecated Use the profileUtil functions instead.
 */
Gate.hasStaffRole = Gate.hasRole(Role.TA);

/**
 * @deprecated Use the profileUtil functions instead.
 */
Gate.hasExperiencedStudentRole = Gate.hasRole(Role.EXPERIENCED_STUDENT);

/**
 * @deprecated Use the profileUtil functions instead.
 */
Gate.hasMentorRole = Gate.hasRole(Role.MENTOR);

/**
 * @deprecated Use the profileUtil functions instead.
 */
Gate.isInCourse = Gate.hasRole(Role.STUDENT);
export default Gate;
